module.exports = "<div style=\"opacity: 1; font-size: 14px;\">\r\n\t<pre><code mwlHighlightJs language=\"html\" [source]=\"code\"></code></pre>\r\n\t<span class=\"copy\" (click)=\"copyCode()\">\r\n\t\t<div class=\"ing-tooltip\">\r\n\t\t\t<div class=\"ing-tooltip-rel\">\r\n\t\t\t\t<i class=\"icon ion-clipboard\" style=\"font-size: 18px;\"></i>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</span>\r\n</div>\r\n<pre class=\"copy-content\" style=\"height: 0; width: 0; overflow: hidden;\">{{code}}</pre>"


//////////////////
// WEBPACK FOOTER
// ./src/app/component/code/code/code.component.html
// module id = ./src/app/component/code/code/code.component.html
// module chunks = common